import { ShieldCheck, Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function Hero({ docCount }) {
  return (
    <section
      className="bg-gradient-to-r from-blue-50 via-indigo-50/40 to-white rounded-2xl border border-blue-100 p-6 sm:p-8 mb-8 shadow-sm relative fade-in-up"
      data-testid="hero-section"
    >
      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              data-testid="compliance-badge"
              aria-label="Napomena o usklađenosti s propisima"
              className="sm:absolute sm:top-6 sm:right-6 mb-4 sm:mb-0 inline-flex bg-blue-100 text-blue-800 border border-blue-200 px-3 py-1 rounded-full text-xs font-semibold items-center gap-1.5 cursor-help focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <ShieldCheck className="w-3.5 h-3.5" />
              Usklađeno s propisima RH
              <Info className="w-3.5 h-3.5 opacity-70" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-sm text-left leading-relaxed" data-testid="compliance-tooltip">
            Trudimo se sve predloške redovito usklađivati s važećim propisima Republike Hrvatske.
            Ipak, propisi se mijenjaju, a mi u Školskoj zbornici nismo pravni stručnjaci, pa potpunu
            točnost i primjenjivost u svakoj situaciji ne možemo jamčiti. Prije uporabe provjerite
            sadržaj dokumenta, a za pravno obvezujuće akte savjetujte se s tajništvom škole ili
            pravnikom. Školska zbornica ne preuzima odgovornost za eventualnu štetu nastalu
            uporabom predložaka.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-slate-900 max-w-3xl">
        Svi školski zahtjevi i obrasci, <span className="text-blue-700">gotovi u minuti</span>
      </h2>
      <p className="mt-4 text-sm sm:text-base text-slate-600 leading-relaxed max-w-2xl">
        Odaberite dokument, ispunite podatke i preuzmite ga kao .docx ili PDF.
        {docCount > 0 && ` Trenutno je dostupno ${docCount} predložaka u 5 kategorija.`} Vaše podatke
        ne vidimo ni mi u Školskoj zbornici niti bilo tko drugi; sve što spremite ostaje samo
        u vašem pregledniku.
      </p>
    </section>
  );
}
